import { type FunctionComponent } from 'react';

import { Form } from '@kanda-libs/ks-component-ts';

import { SuccessOverlay } from 'components';

import OmniSignDocumentsFormBasePage from './BasePage';
import useOmniSignDocumentsForm from './useOmniSignDocumentsForm';

interface OmniSignDocumentsFormProps {
  handleClose?: () => void;
}

const OmniSignDocumentsForm: FunctionComponent<OmniSignDocumentsFormProps> = ({
  handleClose,
}) => {
  const { page, form, onSubmit, isSubmitting } =
    useOmniSignDocumentsForm(handleClose);

  if (page === 'success')
    return (
      <SuccessOverlay
        variant="success"
        message="Credit agreement signed"
        subMessage="Thank you we've now sent you the signed documents to your email. This page should automatically update shortly to inform you of your next steps"
      />
    );

  return (
    <Form id="omni-sign-documents-form" form={form} onSubmit={onSubmit}>
      {page === 'preContact' && (
        <OmniSignDocumentsFormBasePage
          page={page}
          isSubmitting={isSubmitting}
        />
      )}
      {page === 'creditAgreement' && (
        <OmniSignDocumentsFormBasePage
          page={page}
          isSubmitting={isSubmitting}
        />
      )}
      {page === 'directDebit' && (
        <OmniSignDocumentsFormBasePage
          page={page}
          isSubmitting={isSubmitting}
        />
      )}
    </Form>
  );
};

export default OmniSignDocumentsForm;
